import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Model tabs state
  openModelTabs: [],        // Array of tab objects: { id, table_name, fabric_id, fabric_name }
  activeTabId: null,         // Currently active tab ID
  modelDataCache: {},        // Maps modelId -> fetched model data
};

const textractorSlice = createSlice({
  name: 'textractor',
  initialState,
  reducers: {

    // ── Model Tabs ─────────────────────────────────────────
    addModelTab(state, action) {
      state.openModelTabs.push(action.payload);
    },

    removeModelTab(state, action) {
      const modelId = action.payload;
      state.openModelTabs = state.openModelTabs.filter(
        (tab) => tab.id !== modelId
      );
      delete state.modelDataCache[modelId];

      // If closing the active tab, switch to last remaining tab
      if (state.activeTabId === modelId) {
        const remaining = state.openModelTabs;
        state.activeTabId =
          remaining.length > 0 ? remaining[remaining.length - 1].id : null;
      }
    },

    setActiveTabId(state, action) {
      state.activeTabId = action.payload;
    },

    // ── Model Data Cache ───────────────────────────────────
    updateModelDataCache(state, action) {
      const { modelId, data } = action.payload;
      state.modelDataCache[modelId] = data;
    },

    setModelDataCacheFull(state, action) {
      state.modelDataCache = action.payload;
    },

    // ── Reset ──────────────────────────────────────────────
    resetTextractorState() {
      return initialState;
    },
  },
});

export const {
  addModelTab,
  removeModelTab,
  setActiveTabId,
  updateModelDataCache,
  setModelDataCacheFull,
  resetTextractorState,
} = textractorSlice.actions;

export default textractorSlice.reducer;